import { useEffect, useState } from 'react';
import { RemoveRowButtonComponent } from './utilsComponents/RemoveRowButtonComponent';

export const RangeSelectorShippingCost = ({
  min,
  max,
  price,
  coin,
  idx,
  ranges,
  onMinChange,
  onMaxChange,
  onPercentageChange,
  onCoinChange,
  onRemoveRow,
}) => {
  const isLastRecord = idx >= ranges.length - 1;
  const [iconTitle, setIconTitle] = useState('Remover fila');
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);

  useEffect(() => {
    setMinValue(min)
    setMaxValue(max)
  },[min, max])

  const handlerOnMinChange = (value) => {
    setMinValue(value)
    onMinChange(value);
  };

  const handlerOnMaxChange = (value) => {
    setMaxValue(value);
    onMaxChange(value);
  };

  const handlerOnPercentageChange = (value) => {
    onPercentageChange(value);
  };

  const handlerOnCoinChange = (value) => {
    onCoinChange(value);
  };

  return (
    <div className='mb-4 grid grid-cols-8 gap-2'>
      <div className='w-full flex justify-center'>
        <span className='w-[90%] h-full bg-primary-100 text-primary-700 rounded-md items-center justify-center flex'>
          Min
        </span>
      </div>
      <div className={`w-full flex justify-center ${idx == 0 && 'text-center mt-2'}`}>
        {idx > 0 ? (
          <input
            type='number'
            name='min'
            id='min'
            onChange={(e) => handlerOnMinChange(e.target.value)}
            className='block rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2 w-[80%]'
            maxLength='3'
            size='4'
            min={ranges[idx - 1].max}
            max={+ranges[idx].max - 1}
            value={minValue}
          />
        ) : (
          minValue
        )}
      </div>
      <div className='w-full flex justify-center'>
        <span className='w-[90%] h-full bg-primary-100 text-primary-700 rounded-md items-center justify-center flex'>
          Max
        </span>
      </div>
      <div className={`w-full flex justify-center ${isLastRecord && 'text-center mt-2'}`}>
        {!isLastRecord ? (
          <input
            type='number'
            name='max'
            id='max'
            onChange={(e) => handlerOnMaxChange(e.target.value)}
            className='block rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2 w-[80%]'
            maxLength='3'
            size='4'
            min={+ranges[idx].min + 1}
            max={ranges[idx + 1].min}
            value={maxValue}
          />
        ) : (
          !isFinite(maxValue) && 'n'
        )}
      </div>
      <div className='w-full flex justify-center'>
        <span className='w-[90%] h-full bg-primary-100 text-primary-700 rounded-md items-center justify-center flex'>
          kg
        </span>
      </div>
      <div className='w-full flex justify-end'>
        <input
          type='number'
          name='price'
          id='price'
          onChange={(e) => handlerOnPercentageChange(e.target.value)}
          className='block rounded-md border-0 border-gray-300 py-1.5 text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-2 w-[80%]'
          maxLength='3'
          size='4'
          min={0}
          max={100}
          value={price}
        />
      </div>
      <div className='w-full'>
        <select
          id='coin'
          name='coin'
          autoComplete='off'
          className='pl-2 bg-white block w-[85%] h-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6'
          value={coin}
          onChange={(e) => handlerOnCoinChange(e.target.value)}
        >
          <option value={0}>USD</option>
          <option value={1}>EUR</option>
        </select>
      </div>
      {idx > 0 && idx < ranges.length - 1 && (
        <span className='w-full h-full mt-2 flex justify-start'>
          <RemoveRowButtonComponent
            position={idx}
            onRemoveRow={onRemoveRow}
            iconTitle={iconTitle}
          />
        </span>
      )}
    </div>
  );
};
